import { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import Icon, { IconPropsT } from './Icon';

const HomeIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        fill={theme.colors.primary.variant1}
        fillRule="evenodd"
        clipRule="evenodd"
      >
        <path d="M46.34,20.52l-21-19a2,2,0,0,0-2.68,0l-21,19a2,2,0,0,0,2.68,3L24,5.7,43.66,23.48a2,2,0,0,0,2.69-3Z" />
        <path d="M42,26a2,2,0,0,0-2,2V43H32V32a2,2,0,0,0-2-2H18a2,2,0,0,0-2,2V43H8V28a2,2,0,0,0-4,0V45a2,2,0,0,0,2,2H42a2,2,0,0,0,2-2V28A2,2,0,0,0,42,26ZM20,43V34h8v9Z" />
      </svg>
    </Icon>
  );
};

export default HomeIcon;
